var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateApk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1718783092421,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4209,
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544 201.6a31.552 31.552 0 0 0-32 31.04v434.304a32 32 0 0 0 64 0V232.64a31.552 31.552 0 0 0-32-31.04z m0-75.072L329.6 338.112a30.4 30.4 0 0 0 6.4 43.456 32.832 32.832 0 0 0 38.4 0L544 214.016 713.6 377.6a31.424 31.424 0 0 0 43.392 1.344l1.408-1.344a29.76 29.76 0 0 0 0-42.816zM896 832H192a54.528 54.528 0 0 1-64-64v-119.68a32 32 0 0 1 64 0V768h704v-119.68a32 32 0 0 1 64 0V768a67.328 67.328 0 0 1-64 64z",
    fill: "#888888",
    "p-id": 4210
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateApk);
export default __webpack_public_path__ + "static/media/Update_apk.ad98e22bd036828a3a8d3df1869cd7e2.svg";
export { ForwardRef as ReactComponent };